module.exports = __webpack_public_path__ + "static/img/团队成员-刘涛.18a31b62.jpg";